import type { GroupMemberCountFields } from '@ms/yammer-graphql';

import type { GroupMemberCount } from '../../../state/types';

export const processGroupMemberCount: (value: GroupMemberCountFields) => GroupMemberCount = (value) => ({
  id: value.id,
  totalMemberCount: value.memberCount.totalCount,
});
